import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, of } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

@Injectable({
  providedIn: 'root',
})
export class FigureService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  get_figures(): any {
    this.logger.info('FIGURE | get_figures')
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http.get(`${Backend.HOST_CONTAINER + Backend.FIGURE}`, httpOptions).pipe(
      map((res: any) => {
        return res.results
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('FIGURE | get_figures | catchError | errorMessage: ' + errorMessage)
        return of(errorMessage)
      }),
    )
  }

  get_figures_page(username: string, page: number, pageSize: number): any {
    this.logger.info(
      'FIGURE | get_figures_page | username: ' +
        username +
        ' | page: ' +
        page +
        ' | pageSize: ' +
        pageSize,
    )
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(
        `${Backend.HOST_CONTAINER + Backend.FIGURE}?username=${username}&page=${page}&pageSize=${pageSize}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'FIGURE | get_figures_page | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_searched_figures(target: string): any {
    this.logger.info('FIGURE/Search | get_searched_figures | target: ' + target)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.FIGURE}search/?label=${target}`, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'FIGURE/Search | get_searched_figures | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_pub_searched_figures(target: string): any {
    this.logger.info('FIGURE/Search All | get_pub_searched_figures | target: ' + target)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(
        `${Backend.HOST_CONTAINER + Backend.FIGURE}search/?all=true&label=${target}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'FIGURE/Search All | get_pub_searched_figures | catchError | errorMessage: ' +
              errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  add_figure(tag: any): any {
    this.logger.info('FIGURE | add_figure | tag: ' + tag)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const userData = {
      label: tag,
    }

    return this.http.post(`${Backend.HOST_CONTAINER + Backend.FIGURE}`, userData, httpOptions).pipe(
      map((res: any) => {
        return { success: true, res: res }
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('FIGURE | add_figure | catchError | errorMessage: ' + errorMessage)
        return of({ success: false, res: errorMessage })
      }),
    )
  }

  get_figure(figure_id: any): any {
    this.logger.info('FIGURE | get_figure | figure_id: ' + figure_id)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.FIGURE + figure_id + '/'}`, httpOptions)
      .pipe(
        map((res: any) => {
          return { success: true, res: res }
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('FIGURE | get_figure | catchError | errorMessage: ' + errorMessage)
          return of({ success: false, res: errorMessage })
        }),
      )
  }
}
